import AppLayout from '@/layout/AppLayout.vue'
import Home from '@/view/home/Home.vue'
// const Home = () => import('@/view/home/Home.vue')

const routes = {
  path: '/Home',
  name: 'Home',
  icon: 'icon-a-lianhe43',
  meta: {
    title: 'home.homeView'
  },
  component: Home,
}

const components = {}

export default {
  routes,
  components,
}
